import styled, { keyframes } from "styled-components";

const fadeInFromLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const TitleContainer = styled.div`
  opacity: 0;
  color: white;
  padding-top: 10vh;
  padding-left: 10vw;
  padding-right: 10vw;
  font-size: calc(
    100vh * ${(props) => (props.ismobile ? 36 : 72)} /
      ${(props) => (props.ismobile ? 720 : 1080)}
  );
  font-style: arial;
  font-weight: 600;
  line-height: 1.3;
  animation: ${fadeInFromLeft} 1.5s forwards;
`;
export const PageContainer = styled.div`
  background: linear-gradient(#00132c 50%, #181818);
  overflow-x: auto;
  position: relative;
  z-index: 0;
`;

export const SectionContainer = styled.div`
  width: 100%;
  overflow-y: hidden;
  position: relative;
  z-index: 0;
`;
export const FirstSectionContainer1 = styled(SectionContainer)`
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 0;
  background-image: ${(props) =>
    props.ismobile
      ? `linear-gradient( rgba(0, 0, 0, 0) 50%, #00132c), url("${props.bg}")`
      : `linear-gradient( rgba(0, 0, 0, 0) 50%, #00132c), url("${props.bg}")`};

  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
`;
export const FirstSectionContainer = styled(SectionContainer)`
  min-height: 100vh;
  height: auto;
  width: 100%;
  position: relative;
  z-index: 0;
  background-image: ${(props) =>
    `linear-gradient(to right, #000514, rgba(0, 0, 0, 0)), 
      linear-gradient(to right, #000514, rgba(0, 0, 0, 0)), 
     url("${props.bg}")`};

  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
`;
export const SubPageTitle = styled.div`
  font-size: calc(
    100vh * ${(props) => (props.ismobile ? 28 : 48)} /
      ${(props) => (props.ismobile ? 720 : 1080)}
  );
  font-weight: 400;
  color: white;
  padding-top: ${(props) => (props.ismobile ? "5vh" : "5vh")};
  padding-bottom: ${(props) => (props.ismobile ? "5vh" : "5vh")};
  width: 100%;
  text-align: center;
  margin-left: -0.5vw;
`;
export const DetailsContainer = styled.div`
  opacity: 0;
  color: white;
  padding-top: 5vh;
  padding-left: 10vw;
  padding-right: 10vw;
  font-size: calc(
    100vh * ${(props) => (props.ismobile ? 14 : 24)} /
      ${(props) => (props.ismobile ? 720 : 1080)}
  );
  font-style: arial;
  width: auto;
  animation: ${fadeInFromLeft} 1.5s forwards;
`;
export const VideoBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 0;
  }

  .react-player {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto !important;
    height: auto !important;
    aspect-ratio: 16/9;

    video {
      object-fit: cover;
      width: 100vw;
      height: 100vh;
    }
  }
`;
export const SeperatorImage = styled.div`
  min-height: ${(props) => (props.ismobile ? "30vh" : "70vh")};
  height: auto;
  width: 100%;
  position: relative;
  z-index: 0;
  background-image: ${(props) => `url("${props.bg}")`};
  background-color: rgba(204, 204, 204, 0.6);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-blend-mode: overlay;
`;

export const ClientLogo = styled.img`
  max-height: 5vh;
  max-width: 10vw;
  object-fit: contain;
  padding-top: 20px;
  filter: brightness(0) invert(1);
  transition: all 0.3s ease-in-out;

  &:hover {
    filter: drop-shadow(0 0 1px #00dbf8) drop-shadow(0 0 2px #00dbf8)
      drop-shadow(0 0 8px #00dbf8);
    transform: scale(1.05);
  }
`;
